import LeftSidebar from './LeftSidebar';
import TopBar from './TopBar';
import { useState, useEffect } from 'react';

const MainLayout = ({ children, user, onLogout }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f5f7fa' }}>
      <LeftSidebar user={user} onLogout={onLogout} />
      <div 
        style={{
          marginLeft: sidebarCollapsed ? '70px' : '260px',
          flex: 1,
          transition: 'margin-left 0.3s',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <TopBar user={user} onLogout={onLogout} />
        <div className="container" style={{ padding: '2rem', maxWidth: '100%', flex: 1 }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
